// Нижняя навигация до 640 px (FR-039а; contracts/ui.md, «Каркас»): «Главная · Поиск · Создать ·
// Уведомления · Меню». «Поиск» открывает палитру, «Создать» — те же пункты, что «Создать ▾»
// (нет пунктов — нет кнопки), «Меню» — все разделы. Кнопки не меньше 40 × 40 px.
//
// 030 (T019, T020, T059; FR-031, FR-032, FR-034; ASG-DESK-15): сеанс по ссылке — «Мои задачи ·
// Помощь · Меню»; поиск и уведомления у него — в шапке (ux.md, раздел 15: «Меню → раздел → поиск →
// уведомления»), «Создать» нет; «Меню» — то же узкое меню с «Вы вошли как …» и «Выйти». У кого
// «Главная» — это «Мои задачи» (homeIsMyItems), первый пункт — «Мои задачи».
//
// 032 (T026; FR-002): «Уведомления» ведут во «Входящие» (/inbox): на телефоне это список во весь
// экран. Число — непрочитанные «требует действия», как у колокольчика, из того же опроса.
import { Icon } from '@kp/ui';
import { Bell, House, LifeBuoy, ListTodo, Menu, Search } from '@kp/ui/icons';
import { Link } from '@tanstack/react-router';
import type { LinkProps } from '@tanstack/react-router';
import { useShell } from './context.tsx';
import { CreateMenu } from './create.tsx';
import { BellCount, bellLabel, useInboxCounts } from './NotificationsFeed.tsx';
import { INBOX_PATH, MY_ITEMS_PATH, homeIsMyItems } from './permissions.ts';
import { useMe } from './session.ts';

export function BottomNav() {
  const me = useMe();
  if (me.linkSession) return <LinkBottomNav />;
  return <FullBottomNav myHome={homeIsMyItems(me)} />;
}

/** Первый пункт: «Главная» или — у кого она «Мои задачи» — сами «Мои задачи». */
function HomeItem({ myHome }: { myHome: boolean }) {
  return (
    <Link
      to={(myHome ? MY_ITEMS_PATH : '/') as LinkProps['to']}
      className="kp-bn-item"
      activeOptions={{ exact: !myHome }}
      activeProps={{ className: 'is-active', 'aria-current': 'page' }}
    >
      <Icon icon={myHome ? ListTodo : House} />
      <span>{myHome ? 'Мои задачи' : 'Главная'}</span>
    </Link>
  );
}

function MenuItem() {
  const shell = useShell();
  return (
    <button type="button" className="kp-bn-item" onClick={() => shell.setMenuOpen(true)}>
      <Icon icon={Menu} />
      <span>Меню</span>
    </button>
  );
}

function FullBottomNav({ myHome }: { myHome: boolean }) {
  const shell = useShell();
  const counts = useInboxCounts();
  return (
    <nav aria-label="Нижняя навигация" className="kp-bottom-nav">
      <HomeItem myHome={myHome} />
      <button type="button" className="kp-bn-item" onClick={() => shell.setPaletteOpen(true)}>
        <Icon icon={Search} />
        <span>Поиск</span>
      </button>
      <CreateMenu placement="bottom" />
      <Link
        to={INBOX_PATH}
        className="kp-bn-item"
        activeProps={{ className: 'is-active', 'aria-current': 'page' }}
        aria-label={bellLabel(counts)}
      >
        <span className="kp-bn-icon">
          <Icon icon={Bell} />
          <BellCount counts={counts} />
        </span>
        <span aria-hidden="true">Уведомления</span>
      </Link>
      <MenuItem />
    </nav>
  );
}

/** Сеанс по ссылке: «Мои задачи · Помощь · Меню»; поиск и уведомления — в шапке. */
function LinkBottomNav() {
  const shell = useShell();
  return (
    <nav aria-label="Нижняя навигация" className="kp-bottom-nav">
      <HomeItem myHome />
      <button type="button" className="kp-bn-item" onClick={() => shell.openHelp()}>
        <Icon icon={LifeBuoy} />
        <span>Помощь</span>
      </button>
      <MenuItem />
    </nav>
  );
}
